/* eslint-disable */
export default {
  Inbound: 'Saapuvat',
  Outbound: 'Lähtevät',
  log: 'Loki',
  save: 'Tallenna ja uusi',
  discard: 'Hylkää ja uusi',
  hangup: 'Lopeta puhelu',
  reject: 'Vastaajaan',
  saveDraftAndCreateNewLog: 'Tallenna luonnos ja luo uusi puheluloki',
} as const;

// @key: @#@"Inbound"@#@ @source: @#@"Inbound"@#@
// @key: @#@"Outbound"@#@ @source: @#@"Outbound"@#@
// @key: @#@"log"@#@ @source: @#@"Log"@#@
// @key: @#@"save"@#@ @source: @#@"Save and new"@#@
// @key: @#@"discard"@#@ @source: @#@"Discard and new"@#@
// @key: @#@"hangup"@#@ @source: @#@"Hangup"@#@
// @key: @#@"reject"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"saveDraftAndCreateNewLog"@#@ @source: @#@"Save draft and create new call log"@#@
